import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/UniversalRecent';
import './front.scss';

const renderApp = () => {
  const e = document.getElementById('fdnReviewsWidget');

  if(e) {
    ReactDOM.render(<App {...e.dataset}/>, e);
  }
}

renderApp();



// WEBPACK FOOTER //
// ./src/front.js